import CalendarFoldSvg from '@assets/images/svg/calendar-fold.svg';
import React from 'react';
import { View } from 'react-native';

export interface CalendarFoldIconProps {
  size?: number;
  color?: string;
}

/** Figma reservation status — calendar with folded corner */
export function CalendarFoldIcon({
  size = 20,
  color = '#4D4D4D',
}: Readonly<CalendarFoldIconProps>) {
  const height = Math.round((size * 22) / 20);
  return (
    <View
      style={{
        width: size,
        height,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CalendarFoldSvg width={size} height={height} color={color} />
    </View>
  );
}

export default CalendarFoldIcon;
